<template>
  <div class="hooper_slider">
    <template v-if="loading">
      <content-placeholders>
        <content-placeholders-text :lines="4"/>
      </content-placeholders>
    </template>
    <template v-else-if="items.length">
      <div class="catalog-view__cards-wrapper" id="common-analog" style="margin-bottom: 40px">
        <div class="catalog-view__subtitle">
          Аналог оборудования для замены
          <span v-if="items.length > 1">{{ items.length }}</span>
        </div>
        <div class="catalog-view__cards analog_hooper_list">
          <hooper ref="carousel" :itemsToShow="3" :wheelControl="false">
            <slide v-for="(item, key) in items" :key="key" :index="key">
              <a :href="'/catalog/view/' + item.reference">
                <div class="catalog-view__cards-img">
                  <img v-if="item.mainImage" :src="item.mainImage.url" :alt="item.description">
                  <img v-else src="/img/no-photo.png" width="60" height="60" alt="">
                </div>
                <div class="catalog-view__cards-info">
                  <div class="catalog-view__cards-name"><strong class="color-black">{{ item.reference }}</strong></div>
                  <div class="catalog-view__cards-brand">{{ item.brand }}</div>
                  <div class="catalog-view__cards-text">{{ item.description }}</div>
                </div>
              </a>
            </slide>
          </hooper>
          <div v-if="items.length > 3" @click.prevent="slidePrev" class="catalog-view__cards-prev"><img src="/img/arrow-left-icon.svg" width="42" height="47" alt=""></div>
          <div v-if="items.length > 3" @click.prevent="slideNext" class="catalog-view__cards-next"><img src="/img/arrow-left-icon.svg" width="42" height="47" alt=""></div>
        </div>
        <div class="catalog-view__cards__mobile">
          <div v-for="(item, key) in items" :key="key" :index="key" class="slider_list">
            <a :href="'/catalog/view/' + item.reference">
              <div class="catalog-view__cards-img">
                <img v-if="item.mainImage" :src="item.mainImage.url" :alt="item.description">
                <img v-else src="/img/no-photo.png" width="90" height="90" alt="">
              </div>
              <div class="catalog-view__cards-info">
                <div class="catalog-view__cards-name"><strong class="color-black">{{ item.reference }}</strong></div>
                <div class="catalog-view__cards-brand">{{ item.brand }}</div>
                <div class="catalog-view__cards-text">{{ item.description }}</div>
              </div>
            </a>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>

import {Hooper, Slide} from 'hooper';
import 'hooper/dist/hooper.css';
import {EVENT_ADD_CHIPS} from "../../views/ProductCard";

export default {
  name: 'common-analog',
  components: {
    Hooper,
    Slide
  },
  props: {
    product_id: {
      require: true
    }
  },
  data: () => ({
    items: [],
    loading: true
  }),
  created() {
    this.$api.product.commonAnalog(this.product_id).then((response) => {
      if (response && response.data) {
        this.items = response.data
        if (this.items.length) {
          this.$emit(EVENT_ADD_CHIPS, {
            link: 'common-analog',
            title: 'Аналоги оборудования',
            size: this.items.length,
            order: 7
          })
        }
      }
      this.loading = false
    }).catch(() => {
      this.loading = false
    })
  },
  methods: {
    slidePrev() {
      this.$refs.carousel.slidePrev();
    },
    slideNext() {
      this.$refs.carousel.slideNext();
    },
  }
}
</script>